import { render } from "./Dashboard1.vue?vue&type=template&id=72c97c8c&scoped=true"
import script from "./Dashboard1.vue?vue&type=script&lang=js"
export * from "./Dashboard1.vue?vue&type=script&lang=js"

import "./Dashboard1.vue?vue&type=style&index=0&id=72c97c8c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c97c8c"]])

export default __exports__